import React, { useMemo } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'

import { useCartRedux, useConfirmDialog } from '@hooks'
import { GST_STALL_LIST } from '@common'

const CartItem = ({ product, index }) => {
    const { confirm } = useConfirmDialog()
    const { removeItem, removeVariant, plusQuantity, minusQuantity } = useCartRedux()
    const selectionsMap = useMemo(() => {
        return product.selections.reduce(
            (acc, selection) => {
                const selectedOptions = selection.options

                return {
                    price:
                        acc.price +
                        selectedOptions.reduce((optionTotal, option) => optionTotal + option.sellPrice * option.quantity, 0),
                    items: [
                        ...acc.items,
                        ...selectedOptions.map(option => `${option.name} ${option.quantity > 1 ? `x ${option.quantity}` : ''}`),
                    ],
                }
            },
            { price: 0, items: [] }
        )
    }, [product.selections])

    // const totalPrice = useMemo(() => {
    //     return product.variants.reduce(
    //         (total, variant) => total + (variant.sellPrice + selectionsMap.price) * variant.quantity,
    //         0
    //     )
    // }, [product.variants, selectionsMap])

    // const _renderServingTime = () => {
    //     return (
    //         <div className="serving-time-container">
    //             {/* <span className="serving-time-text">{moment(product.servingDate).format('YYYY-MM-DD')}</span> */}
    //         </div>
    //     )
    // }

    const _renderVendorAndProductTitle = () => {
        return (
            <div className="product-details">
                <div className="vendor-container">
                    <div>
                        <p className="product-title">{product.name}</p>
                        <p className="vendor-text">{product.stallName || 'Kopi +'}</p>
                    </div>
                    <i className="bx bx-sm bx-x-circle icon-close align-self-start" onClick={() => confirmRemoveItem(index)} />
                </div>
            </div>
        )
    }

    const _renderProductSelection = () => {
        if (!product?.selections?.length) return null

        return (
            <div className="product-details">
                <div className="selection-container">
                    <p className="selection-text">{selectionsMap.items.join(', ')}</p>
                </div>
            </div>
        )
    }

    const _renderNote = () => {
        if (!product?.note) return null

        return (
            <div className="product-details">
                <p className="note-text">Note: {product.note}</p>
            </div>
        )
    }

    const confirmRemoveItem = async index => {
        const isConfirmed = await confirm('Are you sure you want to remove this item?')
        if (isConfirmed) {
            removeItem(index)
        }
    }

    const confirmRemoveVariant = async (index, variantId) => {
        if (product.variants.find(v => v.id === variantId).quantity === 1) {
            const isConfirmed = await confirm('Are you sure you want to remove this item?')
            if (isConfirmed) {
                removeVariant(index, variantId)
            }
        } else {
            minusQuantity(index, variantId)
        }
    }

    const _renderProductVariant = () => {
        if (!product?.variants?.length) return null

        return (
            <div className="product-details">
                <div className="variant-container">
                    {product.variants.map(variant => (
                        <div key={variant.id} className="variant-item">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="variant-name">{variant.name === 'Default Title' ? '' : variant.name}</p>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-1">
                                <p className="variant-name">S$ {(variant.sellPrice + selectionsMap.price).toFixed(2)}</p>
                                <div className="quantity-container">
                                    <i
                                        className={`bx bx-minus-circle icon`}
                                        onClick={() => confirmRemoveVariant(index, variant.id)}
                                    />
                                    <span className="quantity">{variant.quantity}</span>
                                    <i className="bx bx-plus-circle icon" onClick={() => plusQuantity(index, variant.id)} />
                                </div>
                            </div>
                            {GST_STALL_LIST.includes(product?.stallName) && (
                                <p className="text-secondary m-0" style={{ fontSize: '12px' }}>
                                    (Inclusive of GST)
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <Card className="cart-items">
            <CardBody className="p-3">
                {/* <div className="cart-item-header">
                    {_renderServingTime()}
                    <i className="bx bx-sm bx-x-circle" onClick={() => confirmRemoveItem(index)} />
                </div> */}
                <Row className="align-items-center">
                    <Col xs="12">{_renderVendorAndProductTitle()}</Col>
                    <Col xs="12">
                        {_renderProductSelection()}
                        {_renderNote()}
                        {_renderProductVariant()}
                    </Col>
                    {/* <div className="separator-title"></div>
                    <Col xs="12" className="d-flex justify-content-between align-items-center mt-2">
                        <p className="price-text">Sub Total</p>
                        <p className="price-text">S$ {totalPrice.toFixed(2)}</p>
                    </Col> */}
                </Row>
            </CardBody>
        </Card>
    )
}

const CartList = () => {
    const { items } = useCartRedux()

    return (
        <div className="cart-list">
            {items.map((item, idx) => (
                <CartItem key={idx} product={item} index={idx} />
            ))}
        </div>
    )
}

export default CartList
